import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { type CollectionEntryType } from '@pkg/hooks';

export type NewSaleEvent = {
    profit: number;
    availableCash: number;
    collectionName: string;
};

type SummaryValues = {
    newSale?: NewSaleEvent;
    firstBuy?: CollectionEntryType;
};

interface FantasySummaryState extends SummaryValues {
    setNewSale: (newSale?: NewSaleEvent) => void;
    setFirstBuy: (firstBuy?: CollectionEntryType) => void;
    clearSummary: () => void;
}

const initialState: SummaryValues = {
    newSale: undefined,
    firstBuy: undefined,
};

export const useFantasySummaryStore = create<FantasySummaryState>()(
    devtools(
        (set) => ({
            ...initialState,
            clearSummary: () => set({ ...initialState }),
            setNewSale: (newSale) => set({ newSale }),
            setFirstBuy: (firstBuy) => set({ firstBuy }),
        }),
        { name: 'fantasy-summary-storage' },
    ),
);
